import Blogs from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageBlog from "../../../../../components/sections/admin/Blog/ManageBlog";
import BlogCategory from "../BlogCategory";
import BlogComment from "../BlogComment";
import BlogTags from "../BlogTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-blog",
    path: "/admin/blogs",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/blog-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/blog-tags",
  },
];

export const blogRoutes = () => [
  {
    path: "/admin/blogs",
    component: () => (
      <TabsNavigation title="Blogs Management" tabRoutes={tabRoutes}>
        <Blogs />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
  {
    path: "/admin/blog-categories",
    component: () => (
      <TabsNavigation title="Blogs Management" tabRoutes={tabRoutes}>
        <BlogCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
  {
    path: "/admin/blog-tags",
    component: () => (
      <TabsNavigation title="Blogs Management" tabRoutes={tabRoutes}>
        <BlogTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
  {
    path: "/admin/manage-blogs",
    component: ManageBlog,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
  {
    path: `/admin/manage-blogs/:id`,
    component: ManageBlog,
    layout: "admin",
    routeType: "admin",
    title: "Manage Blogs",
  },
];
